import React from 'react';

const TargetHeight = ({ targetHeight, isMetric, targetText }) => {
  return (
    <p className="label_text">
      {targetText}:{' '}
      <strong>{targetHeight[isMetric ? 'metric' : 'imperial']}{isMetric ? 'cm' : 'in'}</strong>
    </p>
  )
}

export default TargetHeight